export default "__VITE_PUBLIC_ASSET__3ac5e6d5__"